module.exports = __webpack_public_path__ + "img/26.149ed300.svg";